import { render, staticRenderFns } from "./SalesSelect.vue?vue&type=template&id=3386b470&scoped=true"
import script from "./SalesSelect.vue?vue&type=script&lang=js"
export * from "./SalesSelect.vue?vue&type=script&lang=js"
import style0 from "./SalesSelect.vue?vue&type=style&index=0&id=3386b470&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3386b470",
  null
  
)

export default component.exports